import Layout from "src/components/Layout";
import LookerEmbed from "src/components/Looker";

const Looker = () => {
  return (
    <Layout>
      <LookerEmbed />
    </Layout>
  );
};

export default Looker;
